import { Alert, Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { LotacaoResponsavelCard } from 'components/lotacao-responsavel/LotacaoResponsavelCard'
import { CidadaoVisualizacaoQuery } from 'graphql/types.generated'
import { grauParentescoRecord } from 'types/enums'
import { FORA_AREA, MENSAGEM_CIDADAO_FORA_AREA } from 'view/cidadao/constants-cidadao'
import { convertToLotacaoResponsavelCardModel } from 'view/cidadao/create/converter-cidadao'
import { formatCpfCnsResponsavel } from 'view/cidadao/utils-cidadao'

interface ResponsabilidadeAcompanhamentoSectionProps {
  cidadaoNucleoFamiliar: CidadaoVisualizacaoQuery['cidadao']['cidadaoNucleoFamiliar']
  microarea?: string
  isCadastroForaAps?: boolean
  isCadIndividual?: boolean
}

export function ResponsabilidadeAcompanhamentoSection(props: Readonly<ResponsabilidadeAcompanhamentoSectionProps>) {
  const { cidadaoNucleoFamiliar, microarea, isCadastroForaAps, isCadIndividual = false } = props

  const { cpfCnsResponsavel, responsavelFamiliar, isResponsavel, mudouSe, grauParentescoResponsavelFamiliar } =
    cidadaoNucleoFamiliar ?? {}
  const isCidadaoForaArea = !microarea || microarea === FORA_AREA

  const nomeResponsavel = responsavelFamiliar?.nomeSocial ?? responsavelFamiliar?.nome
  const cpfFormatado = formatCpfCnsResponsavel(cpfCnsResponsavel)
  const responsavel = isResponsavel ? 'Sim' : nomeResponsavel?.titleCase()?.trim() || cpfFormatado
  const grauParentesco = grauParentescoRecord[grauParentescoResponsavelFamiliar]

  if (isCadIndividual && isCadastroForaAps) {
    return null
  }

  return (
    <HeadingSection level={2} title={isCadIndividual ? 'Equipe de referência' : 'Responsabilidade de acompanhamento'}>
      <Grid wrap>
        <Cell size={12}>
          <LotacaoResponsavelCard
            responsavel={convertToLotacaoResponsavelCardModel(cidadaoNucleoFamiliar)}
            hideProfissional={isCadIndividual}
            hideCbo={isCadIndividual}
            equipeLabel={isCadIndividual ? 'Equipe' : undefined}
            equipeFallbackLabel={isCadIndividual ? 'Sem equipe específica' : undefined}
          />
        </Cell>
        {mudouSe && (
          <>
            <Cell size={7}>
              <Alert type='info'>Cidadão saiu do território (mudou-se)</Alert>
            </Cell>
            <Cell size={5} />
          </>
        )}
        <Cell size={4}>
          <InfoLabel title='Responsável familiar'>{responsavel}</InfoLabel>
        </Cell>
        {!isResponsavel && (
          <Cell size={4}>
            <InfoLabel title='Grau de parentesco com o responsável'>{grauParentesco}</InfoLabel>
          </Cell>
        )}
        <Cell size={4}>
          <InfoLabel title='Microárea'>{isCidadaoForaArea ? MENSAGEM_CIDADAO_FORA_AREA : microarea}</InfoLabel>
        </Cell>
        {isResponsavel && <Cell size={4} />}
      </Grid>
    </HeadingSection>
  )
}
